module.exports = __webpack_public_path__ + "static/media/rain.459bf6de.png";